import styled from 'styled-components';

export const Main = styled.main`
    max-width: 1210px;
    margin: 0 auto; 
`;